"use strict";
import React from "react";
import _ from "underscore";
import format from "../../formatters/general";
import fetch from "../../util/fetch";
import LineItem, { validId } from "./line_item";
import { List, Map } from "immutable";
import { Flash } from "../../components/flash";
import Api from "../../api/api";
import possibleNonCalculatedAlertIcon from "../ui/line_item_ignored_item_icon";
import lineItemsForCalculation from "../data/line_items_for_calculation";
import quickpayHelper from "../../helpers/quickpay";
import CarrierService from "../../services/carrier_service";
const didChange = (item, field, value) => {
  return parseFloat(item[field]) !== parseFloat(value);
};
const getTotal = (items) => {
  return items.reduce((memo, item) => {
    return memo + parseFloat(item.total);
  }, 0);
};
const fetchLineItems = (carrierInvoiceId) => {
  return fetch(`/api/carrier_invoices/${carrierInvoiceId}/line_items`).then(
    (data) => data
  );
};
function totalChanged(props) {
  var _a;
  (_a = props.invoiceChangeComplete) == null ? void 0 : _a.call(props);
}
function saveLineItem(props, lineItem) {
  const id = lineItem.id || "";
  return fetch(
    `/api/carrier_invoices/${carrierInvoice(props).id}/line_items/${id}`,
    {
      method: validId(lineItem.id) ? "put" : "post",
      data: {
        tms_line_item: lineItem,
        creating_load: props.creatingLoad
      }
    }
  ).then((data) => data);
}
function deleteItem(props, item) {
  return fetch(
    `/api/carrier_invoices/${carrierInvoice(props).id}/line_items/${item.id}`,
    {
      method: "delete",
      data: { creating_load: props.creatingLoad }
    }
  ).then((data) => data);
}
function readOnly(props) {
  return carrierInvoice(props).state == "approved" || carrierInvoice(props).state == "abandoned" || !props.creatingLoad && Api.Account.shouldShowReadOnlyLineItems();
}
function shouldShowReplaceLineItemsDisplay(props, state) {
  if (readOnly(props) || !loadHasLineItems(props)) {
    return false;
  }
  return (!state.lineItemsMatch || state.tmsUpdatedLoad) && !props.creatingLoad;
}
function loadHasLineItems(props) {
  return !_.isEmpty(props.load.load.line_items);
}
function carrierInvoice(props) {
  return props.carrierInvoice;
}
function carrier(props) {
  return CarrierService.getCarrierOrUnknown(carrierInvoice(props).carrier_id);
}
function quickpayDiscountAmount(props) {
  return quickpayHelper.quickpayDiscountAmount(
    invoiceAmount(props),
    carrier(props)
  );
}
function invoiceAmount(props) {
  var amount = parseFloat(
    carrierInvoice(props).amountToPay || carrierInvoice(props).source_invoice_amount
  );
  return isNaN(amount) ? 0 : amount;
}
function replaceLineItemsMessage(state) {
  if (state.tmsUpdatedLoad) {
    return "Line items for this load have been modified in the TMS.";
  } else if (!state.lineItemsMatch) {
    return "Line items do not match line items from load.";
  }
}
function replaceItems(props) {
  return fetch(
    `/api/carrier_invoices/${carrierInvoice(props).id}/replace_line_items`,
    {
      method: "post"
    }
  ).then((data) => data);
}
function noItems(state) {
  if (state.lineItems.isEmpty()) {
    return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box secondary" }, "No line items."));
  }
}
function hasQuickpayAdjustment(props) {
  return quickpayHelper.hasQuickpayAdjustment(
    carrierInvoice(props),
    carrier(props)
  );
}
function possibleQuickpayBreakdown(props) {
  if (carrierInvoice(props).quickpay_disposition == "not_applied_to_invoice" && hasQuickpayAdjustment(props)) {
    return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column possible-adjustments__calculation-line" }, /* @__PURE__ */ React.createElement("div", { className: "operation" }, "-"), format.currency(quickpayDiscountAmount(props))), /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, quickpayHelper.quickpayDiscountAmountUsed(
      invoiceAmount(props),
      carrier(props)
    ), " ", "Quickpay Discount"));
  } else {
    return null;
  }
}
function lineItemTotal(state) {
  return getTotal(state.lineItems);
}
function lineItemDiff(props, state) {
  let diff = lineItemTotal(state) - props.payment.amount;
  if (carrierInvoice(props).quickpay_disposition == "not_applied_to_invoice") {
    diff -= quickpayDiscountAmount(props);
  }
  return diff;
}
const LineItems = React.createClass({
  getInitialState: function() {
    return {
      loading: true,
      lineItems: List([]),
      lineItemsMatch: true,
      tmsUpdatedLoad: false,
      hasIgnoredLineItems: false
    };
  },
  componentWillMount: function() {
    this.getData(this.props);
  },
  componentWillReceiveProps: function(nextProps) {
    if (nextProps.carrierInvoice.id !== carrierInvoice(this.props).id) {
      this.getData(nextProps);
    }
  },
  updateItem: function(item, field, value) {
    const idx = this.state.lineItems.indexOf(item);
    const items = this.state.lineItems;
    const newItem = Map(item).set(field, value).toJS();
    if (!validId(newItem.tms_line_item_type_id) || !didChange(item, field, value)) {
      return Promise.resolve();
    }
    return saveLineItem(this.props, newItem).then((data) => {
      var savedItem = data.tms_line_item;
      const newItems = items.update(idx, () => savedItem);
      this.setState({ lineItems: newItems });
      this.updateMatchData(data.match_results);
      totalChanged(this.props);
      return savedItem;
    });
  },
  setStateAndCallback: function(items) {
    var _a;
    const calculationLineItems = lineItemsForCalculation(
      items,
      Api.Account.currentSettings().ignore_adjustment_line_items
    );
    const hasIgnoredLineItems = calculationLineItems.length !== items.length;
    const lineItemsList = List(calculationLineItems);
    this.setState({
      lineItems: lineItemsList,
      hasIgnoredLineItems
    });
    if (((_a = this.props.carrierInvoice) == null ? void 0 : _a.state) !== "approved") {
      totalChanged(this.props);
    }
    return lineItemsList;
  },
  getLineItems: function(carrierInvoiceId) {
    return fetchLineItems(carrierInvoiceId).then((data) => {
      this.updateMatchData(data.match_results);
      return this.setStateAndCallback(data.tms_line_items);
    });
  },
  addItem: function() {
    const newItem = {
      description: "",
      total: 0,
      new: true,
      id: "",
      tms_data: { rate_qualifier: "FR" }
    };
    const newItems = this.state.lineItems.push(newItem);
    this.setState({ lineItems: newItems });
  },
  updateMatchData: function(match_results) {
    this.setState({
      lineItemsMatch: match_results.line_items_match,
      tmsUpdatedLoad: match_results.tms_updated_load
    });
  },
  removeItem: function(item) {
    return () => {
      const lineItems = this.state.lineItems;
      const newItems = lineItems.delete(lineItems.indexOf(item));
      this.setState({ lineItems: newItems });
      totalChanged(this.props);
      if (validId(item.id)) {
        deleteItem(this.props, item).then((data) => {
          this.updateMatchData(data.match_results);
          Flash.success("Item deleted successfully!");
        }).catch(() => {
          Flash.warning("There was a problem deleting the item");
          this.setState({ lineItems });
        });
      }
    };
  },
  getLineItemTypes: function() {
    return fetch("/api/line_item_types").then((data) => {
      if (this.isMounted()) {
        this.setState({
          lineItemTypes: data.line_item_types
        });
      }
      return data;
    });
  },
  getData: function(props) {
    Promise.all([
      this.getLineItemTypes(),
      this.getLineItems(props.carrierInvoice.id)
    ]).then(() => {
      this.setState({ loading: false });
    });
  },
  // RENDERING
  render: function() {
    const ignoreAdjustmentLineItems = Api.Account.currentSettings().ignore_adjustment_line_items;
    return /* @__PURE__ */ React.createElement("div", { "data-component": "LineItems", className: "line-items" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", { className: "line-item-header" }, "Line items ", this.possibleAddItemLink())), /* @__PURE__ */ React.createElement("div", { className: "line-items__alerts-container" }, this.possibleReplaceLineItemsDisplay(), possibleNonCalculatedAlertIcon(
      this.state.hasIgnoredLineItems,
      ignoreAdjustmentLineItems,
      true
    ), noItems(this.state)), this.lineItems(), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("div", { className: "row possible-adjustments__container" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "small-5 small-offset-5 column\n                              possible-adjustments__factor-calculation"
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "row\n                             possible-adjustments__starting-calculation-line"
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "small-3 column\n                                  possible-adjustments__starting-amount"
          },
          format.currency(this.props.payment.amount)
        ),
        /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, "Payment Amount")
      ),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "row\n                              possible-adjustments__starting-calculation-line"
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "small-3 column\n                                  possible-adjustments__starting-amount"
          },
          format.currency(lineItemTotal(this.state))
        ),
        /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, "Line Item Total")
      ),
      possibleQuickpayBreakdown(this.props),
      /* @__PURE__ */ React.createElement("div", { className: "row possible-adjustments__factor-total-line" }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "small-3 column\n                                  possible-adjustments__total-amount"
        },
        format.currency(lineItemDiff(this.props, this.state))
      ), /* @__PURE__ */ React.createElement("div", { className: "small-7 column possible-adjustments__total-label" }, "Difference"))
    )))));
  },
  possibleAddItemLink: function() {
    if (!readOnly(this.props)) {
      return /* @__PURE__ */ React.createElement("a", { onClick: this.addItem }, /* @__PURE__ */ React.createElement("i", { className: "fi-plus" }));
    }
  },
  possibleReplaceLineItemsDisplay: function() {
    if (shouldShowReplaceLineItemsDisplay(this.props, this.state)) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution line-items__replace-alert" }, replaceLineItemsMessage(this.state), /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.replaceLineItems,
          className: "line-items__replace-button"
        },
        "Replace Line Items"
      )));
    }
  },
  replaceLineItems: function() {
    replaceItems(this.props).then((data) => {
      this.updateMatchData(data.match_results);
      this.setStateAndCallback(data.tms_line_items);
      Flash.success("Line Items Replaced Successfully!");
    });
  },
  lineItems: function() {
    return this.state.lineItems.map(this.lineItem);
  },
  lineItem: function(lineItem, idx) {
    if (!this.state.loading) {
      return /* @__PURE__ */ React.createElement(
        LineItem,
        {
          readOnly: readOnly(this.props),
          creatingLoad: this.props.creatingLoad,
          lineItem,
          updateItem: this.updateItem,
          removeItem: this.removeItem,
          key: "line-item-" + (!validId(lineItem.id) ? `new-${idx}` : lineItem.id),
          lineItemTypes: this.state.lineItemTypes
        }
      );
    }
  }
});
export default LineItems;
